import applicationSurveyReducer from "./applicationSurveyReducer";

const qnrReducers = {
    applicationSurvey: applicationSurveyReducer
}

export default qnrReducers;